import React from 'react'
import { useController } from 'react-hook-form'
import type { Control } from 'react-hook-form'

import DateTimePicker from '@ui-kit/components/formComponents/DateTimePicker'
import type { SegmentedVariantProps } from '@ui-kit/components/formComponents/DateTimePicker/types'

export type Props = Omit<SegmentedVariantProps, 'variant'> & {
  control: Control<any, any>
  defaultValue?: string
}

export const ControlledDateTimePicker = (props: Props) => {
  const { control, defaultValue, ...dateTimePickerProps } = props

  const { field, fieldState } = useController({
    control,
    name: props.name,
    defaultValue,
  })

  const handleChangeText = (newText: string) => {
    field.onChange(newText)
    props.onValueChange?.(newText)
  }

  return (
    <DateTimePicker
      {...dateTimePickerProps}
      variant="segmented"
      value={field.value ? String(field.value) : ''}
      errorMessage={props.errorMessage ?? fieldState.error?.message}
      locale={props.locale ?? 'en-de'}
      name={props.name}
      styleType={props.styleType ?? 'underlined'}
      onValueChange={handleChangeText}
    />
  )
}
